var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 265,
    viewBox: "0 0 265 265",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8062_33050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.332 97.1667C88.332 72.7741 108.106 53 132.499 53C156.891 53 176.665 72.7741 176.665 97.1667C176.665 121.559 156.891 141.333 132.499 141.333C108.106 141.333 88.332 121.559 88.332 97.1667Z",
    fill: "#949494"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.5 0C59.3222 0 0 59.3222 0 132.5C0 205.677 59.3222 265 132.5 265C205.677 265 265 205.677 265 132.5C265 59.3222 205.677 0 132.5 0ZM17.6667 132.5C17.6667 69.0793 69.0793 17.6667 132.5 17.6667C195.922 17.6667 247.333 69.0793 247.333 132.5C247.333 165.176 233.686 194.664 211.779 215.576C209.112 183.885 182.546 159 150.167 159H114.833C82.4546 159 55.8876 183.885 53.2203 215.576C31.3143 194.664 17.6667 165.176 17.6667 132.5Z",
    fill: "#949494"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8062_33050"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 265,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/Profile Icon.f00837511d15fb1a198e6cda9cc5844c.svg";
export { ForwardRef as ReactComponent };